import axios from 'axios'
import { baseUrlAPI } from '@/config/api'

const HOST = baseUrlAPI

export default {
  get (payload = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/type-exams?include_requisites=1`,
        method: 'get'
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  getPlaces () {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/places`,
        method: 'get'
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  getExams (payload = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/extra-exams`,
        method: 'get'
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  getExam (payload = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/type-exams/${payload.id}?include_requisites=${payload.includeRequisites ? 1 : 0}`
      })
        .then(response => resolve(response))
    })
  },

  getExamsEnabled (payload = {}) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/type-exams?enabled=1`,
        method: 'get'
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  getCommunities (payload = {}) {
    // console.log("payload", payload);
    const type = payload.tipo
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/communities?type=${type}`,
        method: 'get'
      })
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  getFullDownload (payload) {
    console.log(localStorage.getItem('token'))

    const getCookieToken = () => {
      const name = 'token='
      const cDecoded = decodeURIComponent(document.cookie)
      const cArr = cDecoded.split('; ')
      let res
      cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length)
      })
      return res
    }

    return new Promise((resolve, reject) => {
		  fetch(`${HOST}/full-download?type=${payload.id}`,
        {
			  method: 'get',
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/zip',
            Authorization: `Bearer ${getCookieToken()}`
          }
		  })
        .then(response => resolve(response))
		  .catch(error => reject(error))
	  })

    /*
	  return new Promise((resolve, reject) => {
		  axios({
			  url: `${HOST}/full-download?type=${payload.id}`,
			  method: 'get',
        accept: 'application/zip',
		  })
		  	.then(response => resolve(response))
		  	.catch(error => reject(error))
    }) */
  }
}
